export default __webpack_public_path__ + "static/media/Skey-Network-Sheet2.b9e515ef.svg";